<form [formGroup]="form" autocomplete="off">
  <section>
    <div class="row">
      <div class="sm:tw-w-1/4">
        <!-- province -->
        <zones-select-search
          label="common.state"
          class="tw-w-full"
          [control]="form?.get('province')"
          [id]="1"
          [value]="selectedProvince"
          (itemChange)="onChangeZones($event)"
          (onError)="onClose()"
        >
        </zones-select-search>
      </div>

      <!-- city -->
      <div class="sm:tw-w-1/4">
        <zones-select-search
          label="common.city"
          class="tw-w-full"
          [control]="form?.get('city')"
          [id]="selectedProvince"
          [value]="model.cityId"
          (itemChange)="model.cityId = $event; onCityChange($event)"
          (onError)="onClose()"
        >
        </zones-select-search>
      </div>

      <!-- class -->
      <div class="sm:tw-w-1/4">
        <form-field
          label="common.class"
          type="number"
          [(value)]="model.class"
          [control]="form?.get('class')"
          (focusout)="onChangeClass()"
        >
        </form-field>
      </div>

      <div class="md:tw-w-1/12 tw-flex-center">
        <button
          class="mat-ripple btn tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise btn-danger"
          (click)="onRemoveClass(index)"
        >
          -
        </button>
      </div>
    </div>
  </section>
</form>
